import { createReducer } from '@reduxjs/toolkit';

import { actions as groupActions } from '../group';
import operations from './operations';

interface SettingsState {
  isLoading: boolean
}

const initialState: SettingsState = {
  isLoading: false,
};

const settingsReducer = createReducer(initialState, (builder) => {
  builder.addCase(operations.updateSettings.pending, (draft) => {
    draft.isLoading = true;
  });

  builder.addCase(operations.updateSettings.fulfilled, (draft) => {
    draft.isLoading = false;
  });

  builder.addCase(operations.updateSettings.rejected, (draft) => {
    draft.isLoading = false;
  });

  builder.addCase(groupActions.fetchGroup.pending, (draft) => {
    draft.isLoading = true;
  });

  builder.addCase(groupActions.fetchGroup.fulfilled, (draft) => {
    draft.isLoading = false;
  });

  builder.addCase(groupActions.fetchGroup.rejected, (draft) => {
    draft.isLoading = false;
  });
});

export default settingsReducer;
export {
  initialState,
  SettingsState,
};
